import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import {
  APP_USER_IDAM_ADD_BUSINESS_PROFILE_ROUTE,
  APP_USER_TAX_ID_CHECK_ROUTE,
  APP_USER_VAT_ID_CHECK_ROUTE,
} from '~shared/constants';
import { UrlUtil } from '~shared/utils/url.util';
import { ACCOUNT_ADD_CARD_URL } from '~shared/constants/links.constants';
import { IdamRegisterTrackingService } from '../../services/idam-register-tracking.service';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
// prettier-ignore
import {
  CountryBasedTierTwoConfigService
} from '~app/modules/authorization/services/country-based-tier-two-config.service';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';

const BACK_URL_KEY = 'backUrl';

@Component({
  selector: 'app-registration-business-type',
  templateUrl: './registration-business-type.component.html',
  styleUrls: ['./registration-business-type.component.scss'],
})
export class RegistrationBusinessTypeComponent implements OnDestroy {
  unsubscribe$ = new Subject();

  constructor(
    private route: ActivatedRoute,
    private serializer: UrlSerializer,
    private router: Router,
    private idamRegisterTrackingService: IdamRegisterTrackingService,
    private countryBasedTierTwoConfigService: CountryBasedTierTwoConfigService
  ) {}

  onHaveCardClick(): void {
    this.trackBusinessRegistrationType(true);
    const redirectUrl = UrlUtil.getAbsoluteUrlWithPath(this.getBackUrl(), { refreshflyout: 1, cardRegister: 1 });
    window.location.href = `${ACCOUNT_ADD_CARD_URL()}?redirectUrl=${encodeURIComponent(redirectUrl)}`;
  }

  onNoCardClick(): void {
    this.trackBusinessRegistrationType(false);
    const queryParams = {
      backUrl: this.getBackUrl(),
    };

    // eslint-disable-next-line no-magic-numbers
    this.countryBasedTierTwoConfigService.getCompanyDetailsFromVATId$.pipe(take(1)).subscribe((isEnabled) => {
      const url = isEnabled ? APP_USER_VAT_ID_CHECK_ROUTE : APP_USER_IDAM_ADD_BUSINESS_PROFILE_ROUTE;
      const urlTree = this.router.createUrlTree(
        [
          MarketDetectionUtil.isDutchMarket() || MarketDetectionUtil.isFrenchMarket()
            ? APP_USER_TAX_ID_CHECK_ROUTE
            : url,
        ],
        { queryParams }
      );
      this.router.navigateByUrl(this.serializer.serialize(urlTree));
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private trackBusinessRegistrationType(withCard: boolean): void {
    this.idamRegisterTrackingService.idamBusinessRegistrationTypeClickEventTracking(withCard);
  }

  private getBackUrl() {
    let backUrl = this.route.snapshot.queryParams.backUrl;

    if (!backUrl) {
      backUrl = localStorage.getItem(BACK_URL_KEY) || null;
    }

    return backUrl;
  }
}
